export default function StoryBlock() {
  return (
    <section id="story" className="w-full px-4 md:px-8 py-12 md:py-16 bg-secondary-50 border-y border-background-200/60">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
        <div className="md:col-span-5">
          <div className="aspect-[4/5] rounded-lg overflow-hidden bg-background-100 ring-1 ring-background-200/60">
            <img
              src="https://readdy.ai/api/search-image?query=Realistic%20editorial%20portrait%20photograph%20of%20a%20Brazilian%20woman%20artisan%20in%20a%20cream%20linen%20apron%20working%20on%20a%20wooden%20studio%20table%20shaping%20clay%20with%20her%20hands%2C%20soft%20morning%20natural%20light%20coming%20through%20a%20window%20behind%20her%2C%20warm%20cozy%20ceramic%20studio%20with%20shelves%20of%20handmade%20pieces%20in%20background%2C%20documentary%20lifestyle%20photography%2C%20muted%20earthy%20palette%2C%20intimate%20slow%20living%20atmosphere&width=1000&height=1250&seq=casaflor-story-01&orientation=portrait"
              alt="Fundadora da Casa Flor trabalhando"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="md:col-span-7">
          <span className="text-[12px] tracking-[0.22em] uppercase text-primary-600">
            Nossa história
          </span>
          <h2 className="font-heading text-3xl md:text-[40px] text-foreground-950 mt-2 leading-[1.15] font-medium">
            Oi, eu sou a Mariana.
          </h2>
          <div className="mt-5 space-y-4 text-[14.5px] text-foreground-700 leading-[1.8] max-w-2xl">
            <p>
              A Casa Flor nasceu do desejo de trazer para dentro de casa a
              beleza do que é feito à mão no Brasil. Cada peça é produzida em
              pequenos lotes, por artesãos e pequenos ateliês de diferentes
              regiões do país.
            </p>
            <p>
              Acreditamos que uma casa bonita é feita de detalhes com história,
              materiais naturais e um toque de imperfeição que só o trabalho
              manual é capaz de criar.
            </p>
          </div>

          <div className="mt-7 flex flex-wrap gap-x-10 gap-y-4">
            <div>
              <p className="font-heading text-2xl text-foreground-950 font-medium">Feito à mão</p>
              <p className="text-[12px] text-foreground-600 mt-0.5">peças únicas</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-foreground-950 font-medium">Pequenos ateliês</p>
              <p className="text-[12px] text-foreground-600 mt-0.5">em todo o Brasil</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-foreground-950 font-medium">Materiais naturais</p>
              <p className="text-[12px] text-foreground-600 mt-0.5">barro, palha e linho</p>
            </div>
          </div>

          <a
            href="/story"
            className="inline-flex items-center gap-2 mt-7 text-[14px] text-foreground-900 hover:text-primary-600 font-medium cursor-pointer underline underline-offset-4"
          >
            Conheça mais
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}